export default {
  items: [
    {
      moduleCode: '',
      screenCode: '',
      name: 'My Tasks',
      url: '/dashboard',
      icon: 'icon-notebook',
      class: 'parent-nav',

      //badge: {
      //  variant: 'info',
      //  text: 'NEW',
      //},
    },
    // User Setup
    {
      moduleCode: '',
      screenCode: 'ADMFRM858',
      name: 'User Management',
      url: '/user',
      icon: 'icon-systemAdmin_1',
      class: 'parent-nav',

      children: [
        {
          moduleCode: '',
          screenCode: 'ADMFRM101',
          name: 'User Setup',
          url: '/admin/user-management/user-list',
          icon: 'icon hidden',
          class: 'child-nav',
        },
        //{
        //  moduleCode: '',
        //  screenCode: 'ADMFRM102',
        //  name: 'Sub Admin Access',
        //  url: '/admin/sub-admin-access/view',
        //  icon: 'icon hidden',
        //  class: 'child-nav',
        //},
        {
          moduleCode: '',
          screenCode: 'ADMFRM857',
          name: 'Setup Roles',
          url: '/admin/setup-role/roles',
          icon: 'icon hidden',
          class: 'child-nav',
        },
      ],
    },
    // System Licensing
    {
      moduleCode: '',
      screenCode: 'ADMFRM320',
      name: 'License',
      url: '/licensing',
      icon: 'icon-systemAdmin_2',
      class: 'parent-nav',

      children: [
        {
          moduleCode: '',
          screenCode: 'ADMFRM320', //ADMFRM155
          name: 'License Info',
          url: '/admin/licenseinfo',
          icon: 'icon hidden',
          class: 'child-nav',
        },
      ],
    },


    // Utilities
    {
      moduleCode: '',
      screenCode: '',
      name: 'Utilities',
      url: '/utilities',
      icon: 'icon-systemAdmin_3',
      class: 'parent-nav',

      children: [
        {
          moduleCode: '',
          screenCode: 'ADMFRM452',
          name: 'Configure System Settings',
          url: '/admin/utilities/configure-system-settings',
          icon: 'icon hidden',
          class: 'child-nav',
        },
        {
          moduleCode: '',
          screenCode: 'ADMFRM630',
          name: 'SMTP Settings for Email Notification',
          url: '/admin/utilities/smtp-settings-email-notification',
          icon: 'icon hidden',
          class: 'child-nav',
        },
        {
          moduleCode: '',
          screenCode: 'ADMFRM604',
          name: 'Customise Email Templates',
          url: '/admin/utilities/customise-email-templates',
          icon: 'icon hidden',
          class: 'child-nav',
        },
        {
          moduleCode: '',
          screenCode: 'ADMFRM111',
          name: 'Language Import Export',
          url: '/admin/languageimportexport',
          icon: 'icon hidden',
          class: 'child-nav',
        },
        {
          moduleCode: '',
          screenCode: 'ADMFRM859',
          name: 'Logo Import',
          url: '/admin/utilities/logo-import',
          icon: 'icon hidden',
          class: 'child-nav',
        },

        {
          moduleCode: '',
          screenCode: 'ADMFRM118',
          name: 'Domain Server Setup',
          url: '/admin/domainserver',
          icon: 'icon hidden',
          class: 'child-nav',
        },
        {
          moduleCode: '',
          screenCode: 'ADMFRM1139',
          name: 'Email Log',
          url: '/admin/utilities/email-log',
          icon: 'icon hidden',
          class: 'child-nav',
        },
        {
          moduleCode: '',
          screenCode: 'ADMFRM127',
          name: 'System Log',
          url: '/admin/systemlog',
          icon: 'icon hidden',
          class: 'child-nav',
        },
        {
          moduleCode: '',
          screenCode: 'ADMFRM904',
          name: 'External Social Setup',
          url: '/admin/externalsocialsetup/externalsocialsetuplist',
          icon: 'icon hidden',
          class: 'child-nav',
        },
      ],
    },
    // Security
    {
      moduleCode: '',
      screenCode: '', //SECADM001
      name: 'Security',
      url: '/security',
      icon: 'icon-systemAdmin_4',
      class: 'parent-nav',
      children: [
        {
          moduleCode: '',
          screenCode: 'SECADM001',
          name: 'Setup Security Settings',
          url: '/admin/security/security-setup-list',
          icon: 'icon hidden',
          class: 'child-nav',
        },
        {
          moduleCode: '',
          screenCode: 'SECADM002',
          name: 'Re-enable Suspended Accounts',
          url: '/admin/security/re-enable-suspended-accounts',
          icon: 'icon hidden',
          class: 'child-nav',
        },
      ],
    },
    // Task Scheduler
    {
      moduleCode: '',
      screenCode: '',
      name: 'Task Scheduler',
      url: '/task_scheduler',
      icon: 'icon-systemAdmin_5',
      class: 'parent-nav',
      children: [
        {
          moduleCode: '',
          screenCode: 'ADMFRM902',
          name: 'View Scheduler History',
          url: '/admin/task-scheduler/view-scheduler-history',
          icon: 'icon hidden',
          class: 'child-nav',
        },
        {
          moduleCode: '',
          screenCode: 'ADMFRM903',
          name: 'View Scheduler List',
          url: '/admin/task-scheduler/view-scheduler-list',
          icon: 'icon hidden',
          class: 'child-nav',
        },
      ],
    },
    // Audit History
    {
      moduleCode: '',
      screenCode: '', //SECADM001
      name: 'Audit History',
      url: '/audit_history',
      icon: 'icon-systemAdmin_6',
      class: 'parent-nav',
      children: [
        {
          moduleCode: '',
          screenCode: 'ADMFRM605',
          name: 'Audit History',
          url: '/admin/audit-history/audit-history',
          icon: 'icon hidden',
          class: 'child-nav',
        },
        {
          moduleCode: '',
          screenCode: 'SECADM006',
          name: 'Administrative Activities',
          url: '/admin/audit-history/administrative-activities',
          icon: 'icon hidden',
          class: 'child-nav',
        },
        {
          moduleCode: '',
          screenCode: 'SECADM003', //SECADM003
          name: 'Login Attempts Audit',
          url: '/admin/audit-history/login-attempts-audit',
          icon: 'icon hidden',
          class: 'child-nav',
        },
        {
          moduleCode: '',
          screenCode: 'SECADM004', //SECADM004
          name: 'User Status History',
          url: '/admin/audit-history/user-status-history',
          icon: 'icon hidden',
          class: 'child-nav',
        },
        {
          moduleCode: '',
          screenCode: 'SECADM007', //SECADM007
          name: 'User Activity Log',
          url: '/admin/audit-history/user-activity-log',
          icon: 'icon hidden',
          class: 'child-nav',
        },
        {
          moduleCode: '',
          screenCode: 'SECADM005', //SECADM005
          name: 'Archive',
          url: '/admin/audit-history/archive',
          icon: 'icon hidden',
          class: 'child-nav',
        },
      ],
    },
  ],
};
